// extracted by mini-css-extract-plugin
export default {"pageLoaderContainer":"_3QqhuPreonPriwTr-OWCuz"};